import React from 'react'
import { PageSection } from '../../page-section'
import { TypeSectionTestimonials } from '../../../lib/types'
import { ContentProps, EntryContentProps } from '../../renderer'

import { TestimonialItem } from './item'
import { TabSection } from '../tabs/tab-section'
import styles from './testimonial.module.scss'

const TestimonialSectionContent: React.FC<EntryContentProps<TypeSectionTestimonials>> = (props) => {
  const {
    structure: {
      fields: { list, middleColumnList, rightColumnList, testimonialType },
    },
  } = props

  if (!list) {
    return null
  }

  switch (testimonialType) {
    case 'social_feed':
      return (
        <div className={styles.socialTestimonialSection}>
          <div>
            {list.map((item) => (
              <TestimonialItem key={item.sys.id} structure={item} />
            ))}
          </div>
          <div className={styles.socialFeedMiddleCol}>
            {middleColumnList?.map((item) => (
              <TestimonialItem key={item.sys.id} structure={item} />
            ))}
          </div>
          <div className={styles.socialFeedRightCol}>
            {rightColumnList?.map((item) => (
              <TestimonialItem key={item.sys.id} structure={item} />
            ))}
          </div>
        </div>
      )
    case 'default':
    default:
      return (
        <>
          {list.map((item) => (
            <TestimonialItem key={item.sys.id} structure={item} />
          ))}
        </>
      )
  }
}

export const TestimonialSection: React.FC<ContentProps<TypeSectionTestimonials>> = ({ className, structure }) => {
  const {
    sys,
    fields: { internalName, background, heading },
  } = structure

  return (
    <PageSection
      internalName={internalName}
      sysStructure={sys}
      className={className}
      heading={heading}
      background={background}
    >
      <TestimonialSectionContent structure={structure} />
    </PageSection>
  )
}

export const TestimonialSectionForTabs: React.FC<ContentProps<TypeSectionTestimonials>> = ({
  className,
  structure,
}) => {
  const {
    fields: { background, heading },
  } = structure

  return (
    <TabSection className={className} heading={heading} background={background}>
      <TestimonialSectionContent structure={structure} />
    </TabSection>
  )
}
